import type { TConstraints } from '@feathr/rachis';

import { TargetableClass } from './targetable.types';
import type { ITargetableBase } from './targetable_base';
import { TargetableBase } from './targetable_base';

/**
 * Interface for lookalike targetables
 * @deprecated in favor of SeedSegmentTargetable
 */
export interface ILookalikeTargetable extends ITargetableBase {
  _cls: TargetableClass.lookalike;
  category_id?: number;
  description?: string;
  full_path?: string;
  mode?: 'auto' | 'manual';
  seed_segment?: string;
  thirdparty_data_id?: string;
  thirdparty_brand_name?: string;
  thirdparty_data_name?: string;
  unique_user_count?: number;
}

/**
 * LookalikeTargetable class for lookalike targetables
 * @deprecated in favor of SeedSegmentTargetable
 */
export class LookalikeTargetable extends TargetableBase<ILookalikeTargetable> {
  public override className = 'Targetable.LookalikeTargetable';

  public override getDefaults(): Partial<ILookalikeTargetable> {
    return {
      ...super.getDefaults(),
      _cls: TargetableClass.lookalike,
    };
  }

  public override get constraints(): TConstraints<ILookalikeTargetable> {
    return {
      ...super.constraints,
      _cls: {
        inclusion: [TargetableClass.lookalike],
      },
      mode: {
        inclusion: ['auto', 'manual'],
      },
      seed_segment: (...args: unknown[]) => {
        const attributes = args[1] as ILookalikeTargetable;
        const { mode } = attributes;
        // Constraint for lookalike auto mode to remain until Lookalike Campaigns are deprecated
        if (mode === 'auto') {
          return {
            presence: {
              allowEmpty: false,
              message: '^Please add a seed group to your target.',
            },
          };
        }
        return undefined;
      },
      thirdparty_data_id: (...args: unknown[]) => {
        const attributes = args[1] as ILookalikeTargetable;
        const { mode } = attributes;
        // Constraint for lookalike manual mode to remain until Lookalike Campaigns are deprecated
        if (mode === 'manual') {
          return {
            presence: {
              allowEmpty: false,
              message: '^Choose an affinity audience for your Target.',
            },
          };
        }
        return undefined;
      },
    };
  }
}
